import { SeonV6 } from '@patrianna/analytics'
import type { SeonDeps } from '@patrianna/analytics'

import { serviceDependencies } from 'src/services'

export const seonDeps: SeonDeps = {
  api: serviceDependencies.fraud,
}

export const seonV6Instanse = new SeonV6(seonDeps)

const { getSeonSessionId: getSeonSessionIdLib, setSeonSessionIdToDB: setSeonSessionIdLib } = seonV6Instanse

export const getSeonSessionId = async () => {
  try {
    const data = await getSeonSessionIdLib()

    return Promise.resolve<string>(data)
  } catch (err) {
    console.warn('getSeonSessionId', err)

    return null
  }
}

export const setSeonSessionIdToDB = async () => {
  try {
    await setSeonSessionIdLib()
  } catch (err) {
    console.warn('setSeonSessionId', err)
  }
}
